import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"

import styles from "./../inputs.less"

class ExpNotationInput extends C {
  constructor(props) {
    super(props)

    this.state = {
      value: props.value || "",
      notValid: props.notValid || false,
    }

    this.regExp = new RegExp(`^-?\\d*(\\${this.props.decimalSign}\\d*)?([eE]-?\\d*)?$`)
  }

  static propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    tabIndex: PropTypes.number,
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    decimalSign: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    isNotValid: PropTypes.bool,
    dataQa: PropTypes.string,
    notValid: PropTypes.bool,
    autoComplete: PropTypes.string,
  }

  state = {
    oldValue: "",
    oldSelectionStart: null,
    oldSelectionEnd: null,
  }

  handleChange(e) {
    this.props.onChange && this.props.onChange(e, e.target.value)
    this.setState({
      value: e.target.value,
      notValid: isNaN(parseFloat(e.target.value)) ? false : !this.valueCheck(e.target.value),
    })
  }

  inputFilter(e) {
    if (this.regExp.test(e.target.value)) {
      this.setState({ oldValue: e.target.value })
      this.setState({ oldSelectionStart: e.target.selectionStart })
      this.setState({ oldSelectionEnd: e.target.selectionEnd })
    } else if (this.state.oldValue) {
      e.target.value = this.state.oldValue
      e.target.setSelectionRange(this.state.oldSelectionStart, this.state.oldSelectionEnd)
    } else {
      e.target.value = ""
    }
  }

  valueCheck(value) {
    return this.regExp.test(value)
  }

  render() {
    let inputClass = classNames(styles.input, this.props.className, {
      disabled: this.props.disabled,
      [styles.notValid]: this.props.notValid || this.state.notValid,
    })

    return (
      <input
        type="text"
        id={this.props.id}
        className={inputClass}
        value={this.state.value}
        onKeyDown={this.inputFilter.bind(this)}
        onKeyUp={this.inputFilter.bind(this)}
        onInput={this.inputFilter.bind(this)}
        onMouseDown={this.inputFilter.bind(this)}
        onMouseUp={this.inputFilter.bind(this)}
        onContextMenu={this.inputFilter.bind(this)}
        onSelect={this.inputFilter.bind(this)}
        onDrop={this.inputFilter.bind(this)}
        onChange={this.handleChange.bind(this)}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        tabIndex={this.props.tabIndex}
        autoFocus={this.props.autoFocus}
        data-qa={this.props.dataQa}
        autoComplete={this.props.autoComplete}
      />
    )
  }
}

export default ValidationMixin(ExpNotationInput)
